<template>
  <div class="hsec">
    <loader v-if="!customHtml"></loader>
    <div class="remoteContent" v-html="customHtml"></div>
<!--    TODO Remove after testing on production-->
    <div v-if="reservedInfo">
      <div class="row top">
        <div class="col header-text">
          <h1>Cookie Policy</h1>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="row">
              <div class="">
                <p class="text-header">What are cookies?</p>
                <p class="text">A cookie is a small file containing a string of characters that is sent to your computer when you visit a www.getincome.com Marketplace (hereinafter
                  “<strong>Marketplace</strong>”). When you visit the site again, the cookie allows that site to recognize your browser. This way, the information you previously provided can be
                  retrieved, so you can easily use customized features. Cookies may store your preferences and other information to enhance your experience on the Marketplace. Overall, cookies are used
                  to help make websites work in a better and more efficient way.</p>
                <p class="text-header">Why we use cookies</p>
                <p class="text">Income Company OÜ (hereinafter “<strong>Income</strong>”) uses cookies for several reasons. Some cookies are required for technical reasons in order for the Marketplace
                  site to operate, and we refer to these as “strictly necessary”. Other cookies enable us to track and target the interests of our candidates to enhance their experience on the
                  Marketplace.</p>
                <p class="text-header">How do we use cookies?</p>
                <p class="text">We use several types of cookies for different purposes:</p>
                <p class="text">
                <ul>
                  <li><span class="underline">Strictly necessary cookies</span>: these cookies are used to ensure the operation of the Marketplace, including allowing you to use our services and connect
                    to your account. These cookies
                    are used based on the legitimate interest of Income to ensure operation of the Marketplace and provide services. The required cookies are saved until you close your browser.
                  </li>
                  <li><span class="underline">Functional cookies</span>: these cookies are created when you first visit the Marketplace. They allow the Marketplace to remember settings you have chosen
                    and choices you have made that
                    make it easier for you to use the Marketplace and register the website from which you have been redirected to the Marketplace. These cookies are used based on the legitimate interest
                    of Income to improve operation of the Marketplace. Functional cookies are kept on your device permanently.
                  </li>
                  <li><span class="underline">Analytical cookies</span>: are used to collect and analyse information about your actions on the Marketplace and to improve Marketplace functionality. These
                    cookies are used based on the
                    legitimate interest of Income to collect statistics on Marketplace visits and to improve operation of the Marketplace. Analytical cookies are kept on your device permanently.
                  </li>
                  <li><span class="underline">Target or promotional cookies</span>: are used to gather information about the websites you visit and segment the visitors of the Marketplace for marketing
                    purposes, including offering
                    you appropriate services by Income or its cooperation partners. These cookies are used based on your consent. When you visit the Marketplace and use the services of Income Company
                    OÜ, you agree that the target cookies are used. Target cookies are kept until you delete them in your browser.
                  </li>
                </ul>
                <p class="text">Cookies are received by Income and its cooperation partners that ensure the operation of the Marketplace, collect and analyse your activities on the Marketplace. Cookie
                  information is not transmitted for processing outside the European Union and the EEA.
                </p>
                <p class="text-header">How to control the use of cookies?</p>
                <p class="text">If you want to restrict, block or delete cookies, you can do that
                  any time by changing the settings of your browser. The way in which you can restrict cookies varies from browser to browser. You should therefore visit your web browser's help menu for
                  more information. Notwithstanding the aforesaid, you are not able to restrict or reject cookies which are strictly necessary to deliver the Marketplace services to you.
                <p class="text-header">Changes in Cookie Policy</p>
                <p class="text">We are authorized to update this Cookie Policy any time. We sometimes do updates to the Cookie Policy to reflect changes to the cookies we use or for other legal or
                  regulatory reasons.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Loader from '@/components/Loader'
import marketingHelper from '@/helpers/marketingHelper'
export default {
  name: 'Cookie',
  components: {Loader},
  data()
  {
    return {
      customHtml: '',
      reservedInfo: false
    }
  },
  mounted()
  {
    marketingHelper.getMarketingRequest('cookie').then((response) =>
    {
      this.customHtml = marketingHelper.parseContent(response)
    }).catch(error =>
    {
      console.log(error)
      this.reservedInfo = true
      this.customHtml = ' '
    })
  }
}
</script>

<style scoped lang="scss">

.hsec {
  .top {
    border-bottom: 1px solid #c3c3c3;
    margin-bottom: 10px;
  }
}

.header-text {
  font-weight: bold;
  margin: 52px auto 16px 5%;

  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 64px;
    line-height: 64px;
    text-align: center;
    color: #000000;
    flex: none;
    max-width: 725px;
    margin: auto auto 15px;
  }

  h3 {
    font-style: normal;
    font-weight: normal;
    font-size: 21px;
    line-height: 28px;
    text-align: center;
    color: #6E777A !important;
    flex: none;
    order: 2;
    align-self: center;
    margin: auto auto 16px;
    max-width: 826px;
  }

  .pre-header {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #9DA0A6;
    flex: none;
    order: 0;
    align-self: center;
    margin: 0 16px 15px;
  }
}

.top-block {
  background-repeat: no-repeat;
  background-size: cover;
}

.top-title {
  font-weight: bold;
  font-size: 36px;
  line-height: 30px;
  text-align: center;
  color: #000000;
  margin-top: 60px;
  margin-bottom: 60px;
  width: 100%;
}

.text-header {
  margin: 45px auto 12px 1%;
  font-weight: bold;
}

.text {
  margin-left: 2%;
  text-align: justify;

  .underline {
    text-decoration: underline;
  }
}
</style>
